import React, { createContext, useCallback, useContext } from 'react';

import eventTracking, { generateTrackingValue, linkTracking } from '@utils/analytics';

const EventTrackingContext = createContext(
  ({ eVarNum = 25, eventKey, disabledEventKey, events }) => {
    console.log('AnalyticsProvider not found.');
    console.table({ eVarNum, eventKey, disabledEventKey, events });
  }
);
const LinkTrackingContext = createContext(
  (eventKey, index, options) => {
    console.log('AnalyticsProvider not found.');
    console.table({ eventKey, index, options });
  }
);

export const useEventTracking = () => useContext(EventTrackingContext);
export const useLinkTracking = () => useContext(LinkTrackingContext);

export const AnalyticsProvider = ({ data, envData, children }) => {
  const { isLocked, registration } = envData;

  const isValidEVarNum = num => !isNaN(parseInt(num));

  const localEventTracking = useCallback((eVarNum, eventKey, events) => {
    const eventData = { [`eVar${ eVarNum }`]: generateTrackingValue(data, eventKey) };
    if (events) {
      // a default event gets applied down the line, so only set this prop if an overwrite is provided
      eventData.events = events;
    }
    return eventTracking(eventData, envData);
  }, [ data, envData ]);

  const partialEventTracking = useCallback(({ eVarNum = 25, eventKey, disabledEventKey, events }) => {
    console.assert(isValidEVarNum(eVarNum), 'Invalid eVarNum provided.');
    if (isLocked) {
      console.assert(disabledEventKey, 'Invalid disabledEventKey provided to locked widget.');
      if (disabledEventKey) {
        localEventTracking(eVarNum, disabledEventKey, events);
      }
      return registration.handleClickDisable();
    }
    console.assert(eventKey, 'Invalid eventKey provided.');
    return localEventTracking(eVarNum, eventKey, events);
  }, [ isLocked, registration, localEventTracking ]);

  const partialLinkTracking = useCallback((eventKey, index, options) => {
    return linkTracking(envData, data, eventKey, index + 1, options);
  }, [ data, envData ]);

  return (
    <EventTrackingContext.Provider value={partialEventTracking}>
      <LinkTrackingContext.Provider value={partialLinkTracking}>
        {children}
      </LinkTrackingContext.Provider>
    </EventTrackingContext.Provider>
  );
};
